import React from 'react';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSaveShortcut } from '../../../hooks/useSaveShortcut';

type ChangeApplicationModalProps = {
  saving: boolean;
  showModal: boolean;
  onCancel: () => void;
  saveAndSelectNext: () => void;
  selectNext: () => void;
};

const ChangeApplicationModal: React.FC<ChangeApplicationModalProps> = props => {
  const { t } = useTranslation();

  // Enable Ctrl+Enter shortcut for save action when modal is open and not saving
  useSaveShortcut(() => props.saveAndSelectNext(), props.showModal && !props.saving);

  return (
    <Modal
      open={props.showModal}
      onCancel={() => props.onCancel()}
      footer={[
        <Button key="cancel" onClick={() => props.onCancel()}>
          {t('common:cancel')}
        </Button>,
        <Button key="next" type="primary" onClick={() => props.selectNext()} danger ghost>
          {t('application:discardAndSelectNext')}
        </Button>,
        <Button
          key="save"
          type="primary"
          loading={props.saving}
          onClick={() => props.saveAndSelectNext()}
        >
          {t('application:saveAndSelectNext')}
        </Button>,
      ]}
      closable={false}
    >
      <div className="text-base font-medium">{t('application:unsavedChanges')}</div>
    </Modal>
  );
};

export default ChangeApplicationModal;
